import "./PaginaNoEncontrada.css";
import { pagina404Descripcion, pagina404titulo } from "./Pagina404txt";
import { useHistory } from "react-router";
import { useContext } from "react";
import { PortalContext } from "../../context/Provider";

const PaginaNoEncontrada = () => {
  const { textosState } = useContext(PortalContext);
  const history = useHistory();

  const volverAlSitioWeb = () => {
    history.push("/autocheckin");
  };

  return (
    <div className="ptur-PaginaNoEncontrada-container bgcG-latex30">
      <div className="ptur-PaginaNoEncontrada-header">
        <img
          className="ptur-loginLeftPanel-logo"
          src={process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"}
          alt="logo"
        ></img>
        <span className="rb24t c-white">
          {textosState.textos.data &&
            (textosState.textos.data.msjPage404
              ? textosState.textos.data.msjPage404.nombre
              : pagina404titulo)}
        </span>
      </div>
      <div className="ptur-PaginaNoEncontrada-body">
        <div className="ptur-PaginaNoEncontrada-txt">
          {textosState.textos.data &&
            (textosState.textos.data.msjPage404 ? (
              <span
                className="rb18l c-white"
                dangerouslySetInnerHTML={{
                  __html: textosState.textos.data.msjPage404.descripcion,
                }}
              ></span>
            ) : (
              <span className="rb18l c-white">{pagina404Descripcion}</span>
            ))}
        </div>
        <div className="ptur-PaginaNoEncontrada-botones">
          <button className="btn bgc-primary" onClick={volverAlSitioWeb}>
            <span className="rb18m c-white">Volver al sitio web</span>{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginaNoEncontrada;
